"use strict";
/**
 * @module Javascript-API
 * copyright defined in eosjs/LICENSE.txt
 */
Object.defineProperty(exports, "__esModule", { value: true });
;
//# sourceMappingURL=eosjs-api-interfaces.js.map